import {
    put, takeLatest, select,
} from 'redux-saga/effects';
import _ from 'underscore';

import { setCookie } from 'helpers/CookiesHelpers';

import {
    SET_COOKIE,
    addToCookiesList,
    removeFromCookiesList,
    getAcceptedCookiesSelector,
} from '../reduxModules/ConsentManagementPlatform';

import { CONSENT_VALIDITY_DURATION } from './initCmpAppSaga';

export function* callAction(action) {
    const { isAccepted, cookieId } = action.payload;

    if (isAccepted) {
        yield put(addToCookiesList({ id: cookieId }));
    } else {
        yield put(removeFromCookiesList({ id: cookieId }));
    }

    const acceptedCookies = yield select(getAcceptedCookiesSelector);
    const cookiesDough = _.pluck(acceptedCookies, 'id');

    setCookie('YPConsent', cookiesDough, CONSENT_VALIDITY_DURATION);
}

export function* watch() {
    yield takeLatest(SET_COOKIE, callAction);
}
